<template>
  <alzata-dialog
    ref="modal"
    size="lg"
    :title="'Delete Administrator'"
    seamless
  >
    <div class="row mt-n4">
      <div class="col-12">
        <span for="name" class="small">Do you want delete "{{name}}"?</span>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide();">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="deleteAdministrator">
        Delete
      </button>
    </template>
  </alzata-dialog>
</template>

<script>

export default {
  name: "DeleteAdministratorDialog",
  emits: ["deleteAdministrator"],
  components: {
  },
  mounted() {
    (async () => {
     
    })();
  },
  data() {
    return {
      administrator: null,
      name: null,
    };
  },
  methods: {
    show(administrator) {
      (async () => {
        this.administrator = administrator;
        this.name = administrator.firstName + ' ' + administrator.lastName;

        this.$refs.modal.show();
      })();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async deleteAdministrator() {
      this.$emit("deleteAdministrator", this.administrator);
    },
  },
};
</script>
